import React from 'react';
import { View, ActivityIndicator } from 'react-native';

import { fullWidth, scale } from '@components/frame';
import { deepClone } from '@helpers';
import Line from '@components/common/line';
import Loading from '@components/loading';
import Refresh from '@components/common/Refresh';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import i18n from 'i18n-js';
import DataGrid from '@components/common/DataGrid';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import { TABLE_NAMES, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { handleToolClick, getDataGridColumns, buildRecentlyViewedEntry } from './helpers';

export default (props) => {
  const {
    C,
    searchResult,
    isError,
    loaded,
    fetchData,
    recentlyViewed,
    setRecentlyViewed,
    isTableMode,
    onItemSelect,
    isPopupMode,
    attachMode,
    attachImageId,
    popupWidth,
  } = props;

  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();
  const { IS_NARROW_WEB } = useDeviceSize();

  const effectiveWidth = isPopupMode && popupWidth ? popupWidth : fullWidth;

  const data = deepClone(searchResult);
  const ncFilesCount = data.reduce((acc, d) => acc + d.ncFileCount, 0);

  const onToolClick = (item) => {
    handleToolClick({
      item,
      isPopupMode,
      onItemSelect,
      attachMode,
      attachImageId,
      navigateToMainDetailsScreen,
      recentlyViewed,
      setRecentlyViewed,
    });
  };

  if (isTableMode) {
    const dataGridColumns = getDataGridColumns(effectiveWidth);
    dataGridColumns[3].headerName = i18n.t('Used in {{ncFileCount}} NC Files', { ncFileCount: ncFilesCount ?? 0 });

    return (
      <View testID={TEST_IDS.searchScreen.tools.dataGridContainer} style={{ width: effectiveWidth, height: '100%' }}>
        <DataGrid
          {...{
            ...props,
            columns: dataGridColumns,
            data,
            onRowClick: onToolClick,
            primaryKey: 'toolName',
            idName: 'toolId',
            tableName: props.tableName || TABLE_NAMES.tools,
          }}
        />
      </View>
    );
  }

  if (isError) {
    return <Refresh onPress={fetchData} />;
  }

  if (!loaded) {
    return <Loading />;
  }

  return (
    <View style={{ width: '100%' }}>
      <View
        style={{
          width: '100%',
          paddingLeft: scale(isPopupMode ? 0 : 15),
          paddingRight: scale(isPopupMode ? 0 : 15),
          marginTop: scale(IS_NARROW_WEB ? 11 : 0),
        }}
      >
        <View testID={TEST_IDS.searchScreen.tools.itemContainer} style={{ width: '100%' }}>
          {searchResult.map((tool, index) => (
            <Line
              {...{
                item: {
                  name: tool.toolName,
                  bottom: tool.description,
                  value: tool.stickoutUM / 1000 || ' ',
                  onClick: () => onToolClick(tool),
                },
                index,
                array: searchResult,
                bigSize: true,
                C,
                topBorder: index !== 0,
                roundTop: index === 0,
                roundBottom: index === searchResult.length - 1,
              }}
              key={tool.toolId}
            />
          ))}
        </View>
      </View>
      {!loaded ? (
        <View style={{ width: '100%', marginTop: scale(20), justifyContent: 'center', height: 50 }}>
          <ActivityIndicator size="small" color="#777777" />
        </View>
      ) : null}
      <View style={{ width: '100%', minHeight: 200 }} />
    </View>
  );
};
